import React from "react";

export interface ChecklistItem {
    title: string;
    hint?: string;
    done: boolean;
}

export default function Checklist({ items }: { items: ChecklistItem[] }) {
    const doneCount = items.filter((i) => i.done).length;
    return (
        <section className="mt-8 border-t border-gray-200 pt-6">
            <div className="mb-4 flex items-baseline justify-between">
                <h3 className="text-lg font-semibold text-[#10231d]">Getting ready to message customers</h3>
                <span className="text-sm text-gray-500">
                    {doneCount} of {items.length} done
                </span>
            </div>
            <ul className="grid gap-x-10 gap-y-4 md:grid-cols-2">
                {items.map((i) => (
                    <li key={i.title} className="flex gap-3">
                        <span
                            className={`mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center rounded border ${
                                i.done ? "border-[#0f7b5a] bg-[#0f7b5a]" : "border-gray-300 bg-white"
                            }`}
                        >
                            {i.done && (
                                <svg width="10" height="10" viewBox="0 0 12 12" fill="none">
                                    <path d="M2.5 6.5l2.5 2.5 4.5-5.5" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            )}
                        </span>
                        <div>
                            <div className={`text-sm font-medium ${i.done ? "text-gray-500" : "text-[#10231d]"}`}>{i.title}</div>
                            {!i.done && i.hint && <div className="mt-0.5 text-xs text-gray-500">{i.hint}</div>}
                        </div>
                    </li>
                ))}
            </ul>
        </section>
    );
}